import { useSelector } from '@xstate/react';
import { useFormMachine } from '../../Form/CarleadCreationForm';
import { jsx as _jsx } from "react/jsx-runtime";
export function LPDataFieldsVisibilityToggle(_ref) {
  let {
    children
  } = _ref;
  const service = useFormMachine();
  const visible = useSelector(service, _ref2 => {
    let {
      context
    } = _ref2;
    return context.invalidMappingFields.length > 0 && context.values.licensePlate === context.previousValues.licensePlate;
  });
  return /*#__PURE__*/_jsx("div", {
    className: visible ? 'd-block' : 'd-none',
    children: children
  });
}